module.exports = __webpack_public_path__ + "static/media/icn_phn_no.7da746c8.svg";